export const MEASUREMENT_UNITS = ["cm", "ft", "kg", "st"] as const;

export type MeasurementUnit = (typeof MEASUREMENT_UNITS)[number];

export type MeasurementValue = {
    value: number | null;
    unit: MeasurementUnit;
};

export function isMeasurementUnit(value: unknown): value is MeasurementUnit {
    return typeof value === "string" && MEASUREMENT_UNITS.includes(value as MeasurementUnit);
}

export function toCanonicalMeasurement(value: number, unit: MeasurementUnit): number {
    if (unit === "ft") return value * 30.48;
    if (unit === "st") return value * 6.35029318;
    return value;
}

export function fromCanonicalMeasurement(value: number, unit: MeasurementUnit): number {
    if (unit === "ft") return value / 30.48;
    if (unit === "st") return value / 6.35029318;
    return value;
}

export function roundMeasurement(value: number, fractionDigits = 6): number {
    const factor = 10 ** fractionDigits;
    return Math.round(value * factor) / factor;
}
